export default __webpack_public_path__ + "static/result-17be41292ed8c4b639c276a390110975.jpg";